import { Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'fls-block-callout-icon',
  styleUrl: 'fls-block-callout-icon.scss',
  shadow: true,
})
export class FlsBlockCalloutIcon {
  @Prop() icon: string;

  render() {
    const icon = () => {
      switch (this.icon) {
        case 'pdf-yellow':
          return (
            <svg class="graphic-PDF-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#ffeace" />
              <path class="secondary" d="M1033.475,2064.511v39.754H988.748v-55.522h28.883" transform="translate(-954.247 -2023.846)" fill="#ffb550" />
              <path class="primary" d="M1055.364,2064.574v-15.83l15.83,15.83Z" transform="translate(-991.967 -2023.846)" fill="#1b526d" />
              <path
                class="primary"
                d="M1031.53,2099.587a8.361,8.361,0,0,0-3.279-1.47,25.992,25.992,0,0,0-6.994-.684,1.264,1.264,0,0,1-1.091-.45c-1.875-1.98-3.637-4.14-5.141-6.009a2.356,2.356,0,0,1-.455-2.568,24.122,24.122,0,0,0,1.5-7.482l-.006-.363a6.445,6.445,0,0,0-.2-1.855,4.228,4.228,0,0,0-3.405-2.96,3.666,3.666,0,0,0-3.325,2.62,8.525,8.525,0,0,0-.6,3.116,14.97,14.97,0,0,0,2.354,8.072,1.174,1.174,0,0,1,.1,1.185c-.967,2.575-2.072,5.115-3.12,7.5a3.481,3.481,0,0,1-2.222,2.056,17.872,17.872,0,0,0-7.326,4.654,6.154,6.154,0,0,0-1.747,3.262,4.154,4.154,0,0,0,1.805,4.063,2.82,2.82,0,0,0,1.329.344,3.6,3.6,0,0,0,1.965-.67,12.564,12.564,0,0,0,3.08-3.1,43.981,43.981,0,0,0,3.979-6.483,1,1,0,0,1,.664-.573,49.05,49.05,0,0,1,9.642-1.683.862.862,0,0,1,.739.29c1.16,1.14,2.066,2,2.936,2.8a10.808,10.808,0,0,0,4.527,2.7,4.334,4.334,0,0,0,5.08-1.979A3.125,3.125,0,0,0,1031.53,2099.587Zm-8.174.51h.165a19.311,19.311,0,0,1,5.192.936,5.579,5.579,0,0,1,.568.257c1,.51.9.867.841,1.059a1.581,1.581,0,0,1-1.6,1.07,6.334,6.334,0,0,1-2.639-1.134,15.7,15.7,0,0,1-2.112-1.775l-.442-.415Zm-11.025-13.475a10.525,10.525,0,0,1-.965-6.455,3.514,3.514,0,0,1,.64-1.471c.183-.239.288-.273.324-.276s.148.011.368.216a2.724,2.724,0,0,1,.786,2.156A27.72,27.72,0,0,1,1012.331,2086.621Zm-1.442,11.313c.223-.494.446-.989.659-1.49.546-1.288,1.032-2.469,1.487-3.61l.015-.038c1.4,1.825,2.888,3.516,4.055,4.81a54.736,54.736,0,0,0-6.571,1.12Q1010.71,2098.329,1010.889,2097.934Zm-5.778,5.459a32.679,32.679,0,0,1-3.654,5.168,5.938,5.938,0,0,1-1.475,1.25c-.229.125-.339.122-.5-.146a1.735,1.735,0,0,1,.151-2.051,11.94,11.94,0,0,1,4.511-3.725l.241-.126C1004.623,2103.637,1004.862,2103.511,1005.111,2103.393Z"
                transform="translate(-958.655 -2039.134)"
                fill="#1b526d"
              />
            </svg>
          );
        case 'pdf-blue':
          return (
            <svg class="graphic-PDF-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#D3E8F2" />
              <path class="secondary" d="M1033.475,2064.511v39.754H988.748v-55.522h28.883" transform="translate(-954.247 -2023.846)" fill="#5BA6BF" />
              <path class="primary" d="M1055.364,2064.574v-15.83l15.83,15.83Z" transform="translate(-991.967 -2023.846)" fill="#1b526d" />
              <path
                class="primary"
                d="M1031.53,2099.587a8.361,8.361,0,0,0-3.279-1.47,25.992,25.992,0,0,0-6.994-.684,1.264,1.264,0,0,1-1.091-.45c-1.875-1.98-3.637-4.14-5.141-6.009a2.356,2.356,0,0,1-.455-2.568,24.122,24.122,0,0,0,1.5-7.482l-.006-.363a6.445,6.445,0,0,0-.2-1.855,4.228,4.228,0,0,0-3.405-2.96,3.666,3.666,0,0,0-3.325,2.62,8.525,8.525,0,0,0-.6,3.116,14.97,14.97,0,0,0,2.354,8.072,1.174,1.174,0,0,1,.1,1.185c-.967,2.575-2.072,5.115-3.12,7.5a3.481,3.481,0,0,1-2.222,2.056,17.872,17.872,0,0,0-7.326,4.654,6.154,6.154,0,0,0-1.747,3.262,4.154,4.154,0,0,0,1.805,4.063,2.82,2.82,0,0,0,1.329.344,3.6,3.6,0,0,0,1.965-.67,12.564,12.564,0,0,0,3.08-3.1,43.981,43.981,0,0,0,3.979-6.483,1,1,0,0,1,.664-.573,49.05,49.05,0,0,1,9.642-1.683.862.862,0,0,1,.739.29c1.16,1.14,2.066,2,2.936,2.8a10.808,10.808,0,0,0,4.527,2.7,4.334,4.334,0,0,0,5.08-1.979A3.125,3.125,0,0,0,1031.53,2099.587Zm-8.174.51h.165a19.311,19.311,0,0,1,5.192.936,5.579,5.579,0,0,1,.568.257c1,.51.9.867.841,1.059a1.581,1.581,0,0,1-1.6,1.07,6.334,6.334,0,0,1-2.639-1.134,15.7,15.7,0,0,1-2.112-1.775l-.442-.415Zm-11.025-13.475a10.525,10.525,0,0,1-.965-6.455,3.514,3.514,0,0,1,.64-1.471c.183-.239.288-.273.324-.276s.148.011.368.216a2.724,2.724,0,0,1,.786,2.156A27.72,27.72,0,0,1,1012.331,2086.621Zm-1.442,11.313c.223-.494.446-.989.659-1.49.546-1.288,1.032-2.469,1.487-3.61l.015-.038c1.4,1.825,2.888,3.516,4.055,4.81a54.736,54.736,0,0,0-6.571,1.12Q1010.71,2098.329,1010.889,2097.934Zm-5.778,5.459a32.679,32.679,0,0,1-3.654,5.168,5.938,5.938,0,0,1-1.475,1.25c-.229.125-.339.122-.5-.146a1.735,1.735,0,0,1,.151-2.051,11.94,11.94,0,0,1,4.511-3.725l.241-.126C1004.623,2103.637,1004.862,2103.511,1005.111,2103.393Z"
                transform="translate(-958.655 -2039.134)"
                fill="#1b526d"
              />
            </svg>
          );
        case 'support-yellow':
          return (
            <svg class="graphic-support-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#ffeace" />
              <ellipse class="secondary" cx="28.132" cy="28.103" rx="28.132" ry="28.103" transform="translate(25 24.039)" fill="#ffb550" />
              <path
                class="primary"
                d="M95.523,62.874V53.643a37.143,37.143,0,1,0-74.286,0v9.231l-.206,5.247A16.475,16.475,0,0,0,37.487,84.577h1.978V51.665H37.487A16.418,16.418,0,0,0,25.193,57.2V53.643a33.187,33.187,0,1,1,66.374,0v3.949a16.418,16.418,0,0,0-12.294-5.533H77.295V84.971h1.978a16.439,16.439,0,0,0,3.587-.4v3.966a4.011,4.011,0,0,1-4.007,4.007H68.571a4.238,4.238,0,0,0-3.664-2.111H51.853a4.242,4.242,0,0,0,0,8.485H64.907A4.238,4.238,0,0,0,68.732,96.5H78.854a7.972,7.972,0,0,0,7.963-7.963V83.132a16.469,16.469,0,0,0,8.913-14.618Zm-60.014-7.1V80.465a12.5,12.5,0,0,1,0-24.688ZM81.251,80.858V56.171a12.5,12.5,0,0,1,0,24.687Z"
                transform="translate(-5.031 -2.418)"
                fill="#1b526d"
              />
            </svg>
          );
        case 'support-blue':
          return (
            <svg class="graphic-support-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#d3e8f2" />
              <ellipse class="secondary" cx="28.132" cy="28.103" rx="28.132" ry="28.103" transform="translate(25 24.039)" fill="#5ba6bf" />
              <path
                class="primary"
                d="M95.523,62.874V53.643a37.143,37.143,0,1,0-74.286,0v9.231l-.206,5.247A16.475,16.475,0,0,0,37.487,84.577h1.978V51.665H37.487A16.418,16.418,0,0,0,25.193,57.2V53.643a33.187,33.187,0,1,1,66.374,0v3.949a16.418,16.418,0,0,0-12.294-5.533H77.295V84.971h1.978a16.439,16.439,0,0,0,3.587-.4v3.966a4.011,4.011,0,0,1-4.007,4.007H68.571a4.238,4.238,0,0,0-3.664-2.111H51.853a4.242,4.242,0,0,0,0,8.485H64.907A4.238,4.238,0,0,0,68.732,96.5H78.854a7.972,7.972,0,0,0,7.963-7.963V83.132a16.469,16.469,0,0,0,8.913-14.618Zm-60.014-7.1V80.465a12.5,12.5,0,0,1,0-24.688ZM81.251,80.858V56.171a12.5,12.5,0,0,1,0,24.687Z"
                transform="translate(-5.031 -2.418)"
                fill="#1b526d"
              />
            </svg>
          );
        case 'email-yellow':
          return (
            <svg class="graphic-email-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <circle class="tertiary" cx="53.5" cy="53.5" r="53.5" fill="#ffeace" />
              <path
                class="primary"
                d="M90.721,90.146h-44.1V61.795L68.669,44.616,90.721,61.795ZM48.787,87.978H88.552V62.854L68.669,47.365,48.787,62.854Z"
                transform="translate(-13.168 -18.472)"
                fill="#1b526d"
              />
              <rect class="secondary" width="39.042" height="31.457" transform="translate(71.229 31.549) rotate(90)" fill="#ffb550" />
              <path
                class="primary"
                d="M90.721,119.967h-44.1V91.636l4.034-.072,18.02,11.367L86.915,91.564l3.806.074ZM48.787,117.8H88.552V93.763l-1.036-.02L68.666,105.49,50.043,93.743l-1.256.022Z"
                transform="translate(-13.168 -48.427)"
                fill="#1b526d"
              />
              <line class="primary" x2="19.862" transform="translate(8.953 52.031)" fill="none" stroke="#1b526d" stroke-width="2" />
              <line class="primary" x2="14.565" transform="translate(14.25 57.327)" fill="none" stroke="#1b526d" stroke-width="2" />
              <line class="primary" x2="9.269" transform="translate(19.546 62.624)" fill="none" stroke="#1b526d" stroke-width="2" />
              <path class="primary" d="M4588.162,2875.063l6.177,4.37,12.271-9.528" transform="translate(-4539.932 -2834.074)" fill="none" stroke="#1b526d" stroke-width="2" />
            </svg>
          );
        case 'email-blue':
          return (
            <svg class="graphic-email-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <circle class="tertiary" cx="53.5" cy="53.5" r="53.5" fill="#d3e8f2" />
              <path
                class="primary"
                d="M90.721,90.146h-44.1V61.795L68.669,44.616,90.721,61.795ZM48.787,87.978H88.552V62.854L68.669,47.365,48.787,62.854Z"
                transform="translate(-13.168 -18.472)"
                fill="#1b526d"
              />
              <rect class="secondary" width="39.042" height="31.457" transform="translate(71.229 31.549) rotate(90)" fill="#5ba6bf" />
              <path
                class="primary"
                d="M90.721,119.967h-44.1V91.636l4.034-.072,18.02,11.367L86.915,91.564l3.806.074ZM48.787,117.8H88.552V93.763l-1.036-.02L68.666,105.49,50.043,93.743l-1.256.022Z"
                transform="translate(-13.168 -48.427)"
                fill="#1b526d"
              />
              <line class="primary" x2="19.862" transform="translate(8.953 52.031)" fill="none" stroke="#1b526d" stroke-width="2" />
              <line class="primary" x2="14.565" transform="translate(14.25 57.327)" fill="none" stroke="#1b526d" stroke-width="2" />
              <line class="primary" x2="9.269" transform="translate(19.546 62.624)" fill="none" stroke="#1b526d" stroke-width="2" />
              <path class="primary" d="M4588.162,2875.063l6.177,4.37,12.271-9.528" transform="translate(-4539.932 -2834.074)" fill="none" stroke="#1b526d" stroke-width="2" />
            </svg>
          );
        case 'bulb-yellow':
          return (
            <svg class="graphic-bulb-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#ffeace" />
              <path
                class="secondary"
                d="M82.122,46.2A27.053,27.053,0,1,0,36.757,66.189a18.194,18.194,0,0,1,5.989,13.334H67.39a18.194,18.194,0,0,1,5.989-13.334A27.122,27.122,0,0,0,82.122,46.2"
                transform="translate(-1.569 -1.232)"
                fill="#ffb550"
              />
              <path
                class="primary"
                d="M55.891,99.636a12.091,12.091,0,0,1-11.9-10.285l-1.288-8.793h26.37l-1.287,8.793a12.091,12.091,0,0,1-11.9,10.285M46.42,83.768l.749,5.119a8.816,8.816,0,0,0,17.445,0l.749-5.119Z"
                transform="translate(-2.391 -4.945)"
                fill="#1b526d"
              />
              <rect class="primary" width="16.143" height="3.209" transform="translate(51.571 76.678) rotate(-88.854)" fill="#1b526d" />
              <path
                class="primary"
                d="M65.137,67l-2.549-1.02a18.145,18.145,0,0,0-14.189.369l-1.34.618-1.344-2.915,1.34-.618a21.316,21.316,0,0,1,8.867-1.947A21.054,21.054,0,0,1,63.78,63l2.55,1.02Z"
                transform="translate(-2.56 -3.69)"
                fill="#1b526d"
              />
            </svg>
          );
        case 'bulb-blue':
          return (
            <svg class="graphic-bulb-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#d3e8f2" />
              <path
                class="secondary"
                d="M82.122,46.2A27.053,27.053,0,1,0,36.757,66.189a18.194,18.194,0,0,1,5.989,13.334H67.39a18.194,18.194,0,0,1,5.989-13.334A27.122,27.122,0,0,0,82.122,46.2"
                transform="translate(-1.569 -1.232)"
                fill="#5ba6bf"
              />
              <path
                class="primary"
                d="M55.891,99.636a12.091,12.091,0,0,1-11.9-10.285l-1.288-8.793h26.37l-1.287,8.793a12.091,12.091,0,0,1-11.9,10.285M46.42,83.768l.749,5.119a8.816,8.816,0,0,0,17.445,0l.749-5.119Z"
                transform="translate(-2.391 -4.945)"
                fill="#1b526d"
              />
              <rect class="primary" width="16.143" height="3.209" transform="translate(51.571 76.678) rotate(-88.854)" fill="#1b526d" />
              <path
                class="primary"
                d="M65.137,67l-2.549-1.02a18.145,18.145,0,0,0-14.189.369l-1.34.618-1.344-2.915,1.34-.618a21.316,21.316,0,0,1,8.867-1.947A21.054,21.054,0,0,1,63.78,63l2.55,1.02Z"
                transform="translate(-2.56 -3.69)"
                fill="#1b526d"
              />
            </svg>
          );
        case 'mouse-yellow':
          return (
            <svg class="graphic-mouse-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#ffeace" />
              <path
                class="primary"
                d="M66.5,97.95c-8.826,0-16.007-7.838-16.007-17.474v-31.2h3.747v31.2c0,7.569,5.5,13.728,12.261,13.728s12.26-6.159,12.26-13.728L78.9,53.61V45.844a12.925,12.925,0,0,1,12.91-12.91h9.652V36.68H91.814a9.175,9.175,0,0,0-9.164,9.164V53.62l-.142,26.866c0,9.626-7.18,17.464-16.007,17.464"
                transform="translate(-2.827 -2.278)"
                fill="#1b526d"
              />
              <path class="secondary" d="M73.878,47.675V39.529A21.786,21.786,0,0,0,52.156,17.807V47.675Z" transform="translate(-2.921 -1.091)" fill="#ffb550" />
              <path
                class="primary"
                d="M47.121,21.946V43.929H32.89v-4.4A18.009,18.009,0,0,1,47.121,21.946m3.746-4.139h0A21.786,21.786,0,0,0,29.144,39.529v8.146H50.866Z"
                transform="translate(-1.632 -1.091)"
                fill="#1b526d"
              />
              <path class="secondary" d="M50.866,49.447H29.144v12.1a21.722,21.722,0,1,0,43.445,0v-12.1Z" transform="translate(-1.632 -3.044)" fill="#ffb550" />
            </svg>
          );
        case 'mouse-blue':
          return (
            <svg class="graphic-mouse-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#d3e8f2" />
              <path
                class="primary"
                d="M66.5,97.95c-8.826,0-16.007-7.838-16.007-17.474v-31.2h3.747v31.2c0,7.569,5.5,13.728,12.261,13.728s12.26-6.159,12.26-13.728L78.9,53.61V45.844a12.925,12.925,0,0,1,12.91-12.91h9.652V36.68H91.814a9.175,9.175,0,0,0-9.164,9.164V53.62l-.142,26.866c0,9.626-7.18,17.464-16.007,17.464"
                transform="translate(-2.827 -2.278)"
                fill="#1b526d"
              />
              <path class="secondary" d="M73.878,47.675V39.529A21.786,21.786,0,0,0,52.156,17.807V47.675Z" transform="translate(-2.921 -1.091)" fill="#5ba6bf" />
              <path
                class="primary"
                d="M47.121,21.946V43.929H32.89v-4.4A18.009,18.009,0,0,1,47.121,21.946m3.746-4.139h0A21.786,21.786,0,0,0,29.144,39.529v8.146H50.866Z"
                transform="translate(-1.632 -1.091)"
                fill="#1b526d"
              />
              <path class="secondary" d="M50.866,49.447H29.144v12.1a21.722,21.722,0,1,0,43.445,0v-12.1Z" transform="translate(-1.632 -3.044)" fill="#5ba6bf" />
            </svg>
          );
        case 'vial-yellow':
          return (
            <svg class="graphic-vial-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#ffeace" />
              <rect class="secondary" width="31" height="44" transform="translate(38.639 46.678)" fill="#ffb550" />
              <path
                class="primary"
                d="M37,80H0V32.5A18.44,18.44,0,0,1,7.5,17.637V8h22v9.638A18.436,18.436,0,0,1,37,32.5ZM4,76H33V32.5a14.465,14.465,0,0,0-6.593-12.144l-.907-.591V12h-14v7.764l-.906.591A14.468,14.468,0,0,0,4,32.5Z"
                transform="translate(35 13.566)"
                fill="#1b526d"
              />
              <rect class="primary" width="17" height="4" transform="translate(37 62.736)" fill="#1b526d" />
              <rect class="primary" data-name="graphic-vial-yellow-line" width="17" height="4" transform="translate(37 71.947)" fill="#1b526d" />
              <path class="secondary" d="M0,0H31V14H0Z" transform="translate(37.639 14)" fill="#ffb550" />
            </svg>
          );
        case 'vial-blue':
          return (
            <svg class="graphic-vial-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#d3e8f2" />
              <rect class="secondary" width="31" height="44" transform="translate(38.639 46.678)" fill="#5ba6bf" />
              <path
                class="primary"
                d="M37,80H0V32.5A18.44,18.44,0,0,1,7.5,17.637V8h22v9.638A18.436,18.436,0,0,1,37,32.5ZM4,76H33V32.5a14.465,14.465,0,0,0-6.593-12.144l-.907-.591V12h-14v7.764l-.906.591A14.468,14.468,0,0,0,4,32.5Z"
                transform="translate(35 13.566)"
                fill="#1b526d"
              />
              <rect class="primary" width="17" height="4" transform="translate(37 62.736)" fill="#1b526d" />
              <rect class="primary" data-name="graphic-vial-yellow-line" width="17" height="4" transform="translate(37 71.947)" fill="#1b526d" />
              <path class="secondary" d="M0,0H31V14H0Z" transform="translate(37.639 14)" fill="#5ba6bf" />
            </svg>
          );
        case 'external-link-yellow':
          return (
            <svg class="graphic-external-link-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#ffeace" />
              <path
                class="primary"
                d="M1035.47,109.948h-56.4v-56.4h37.812a18.609,18.609,0,0,1,18.589,18.588Zm-53.378-3.021h50.357V72.136a15.584,15.584,0,0,0-15.567-15.567h-34.79Z"
                transform="translate(-954.07 -26.266)"
                fill="#1b526d"
              />
              <path
                class="secondary"
                d="M1026.048,49.548V61.13h11.6l-17.784,17.784,8.19,8.19,18.1-18.1V80.363h11.582V49.548Z"
                transform="translate(-972.324 -26.205)"
                fill="#ffb550"
              />
            </svg>
          );
        case 'external-link-blue':
          return (
            <svg class="graphic-external-link-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 106.999 107">
              <path class="tertiary" d="M53.5,0A53.5,53.5,0,1,1,0,53.5,53.5,53.5,0,0,1,53.5,0" fill="#d3e8f2" />
              <path
                class="primary"
                d="M1035.47,109.948h-56.4v-56.4h37.812a18.609,18.609,0,0,1,18.589,18.588Zm-53.378-3.021h50.357V72.136a15.584,15.584,0,0,0-15.567-15.567h-34.79Z"
                transform="translate(-954.07 -26.266)"
                fill="#1b526d"
              />
              <path
                class="secondary"
                d="M1026.048,49.548V61.13h11.6l-17.784,17.784,8.19,8.19,18.1-18.1V80.363h11.582V49.548Z"
                transform="translate(-972.324 -26.205)"
                fill="#5ba6bf"
              />
            </svg>
          );
        case 'zip-yellow':
          return (
            <svg class="graphic-zip-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#ffeace" />
              <path class="primary" d="M13.217,96.506H51.193l8.853,17.5H4.568Zm-1.764-2.837L0,116.845H64.661L52.938,93.669Z" transform="translate(21 -32.365)" fill="#1b526d" />
              <path
                class="secondary"
                d="M43.759,0A22.074,22.074,0,0,0,21.685,22.074c0,12.191,22.074,36.893,22.074,36.893s22.074-24.7,22.074-36.893A22.074,22.074,0,0,0,43.759,0m0,34.587A12.04,12.04,0,1,1,55.8,22.547a12.04,12.04,0,0,1-12.04,12.04"
                transform="translate(9.571 17)"
                fill="#ffb550"
              />
            </svg>
          );
        case 'zip-blue':
          return (
            <svg class="graphic-zip-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#d3e8f2" />
              <path class="primary" d="M13.217,96.506H51.193l8.853,17.5H4.568Zm-1.764-2.837L0,116.845H64.661L52.938,93.669Z" transform="translate(21 -32.365)" fill="#1b526d" />
              <path
                class="secondary"
                d="M43.759,0A22.074,22.074,0,0,0,21.685,22.074c0,12.191,22.074,36.893,22.074,36.893s22.074-24.7,22.074-36.893A22.074,22.074,0,0,0,43.759,0m0,34.587A12.04,12.04,0,1,1,55.8,22.547a12.04,12.04,0,0,1-12.04,12.04"
                transform="translate(9.571 17)"
                fill="#5ba6bf"
              />
            </svg>
          );
        case 'phone-yellow':
          return (
            <svg class="graphic-phone-yellow graphic-yellow" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
              <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#ffeace" />
              <path
                class="secondary"
                d="M22.2,64.456c7.091,4.1,16.659,6.886,29.011,5.084l.665-15.495L35.926,49.6c-1.383.99-3.734,2.838-5.125,3.818,0,0-3.255-.784-7.707-4.96l-1.129-1.087c-4.176-4.453-4.959-7.707-4.959-7.707.98-1.391,2.827-3.742,3.818-5.125L16.373,18.58.879,19.245S-6.621,46.459,22.2,64.456"
                transform="translate(21 14.294)"
                fill="#ffb550"
              />
              <path
                class="primary"
                d="M45.259,26.4h-.293v3.45h.293A18.784,18.784,0,0,1,64.022,48.608V48.9h3.449v-.293A22.238,22.238,0,0,0,45.259,26.4"
                transform="translate(2.351 11.053)"
                fill="#1b526d"
              />
              <path
                class="primary"
                data-name="graphic-phone-yellow-sound"
                d="M45.259,13.255h-.293V16.7h.293A26.484,26.484,0,0,1,71.712,43.158v.293h3.45v-.293a29.937,29.937,0,0,0-29.9-29.9"
                transform="translate(2.351 16.503)"
                fill="#1b526d"
              />
              <path
                class="primary"
                data-name="graphic-phone-yellow-sound"
                d="M45.259,0h-.293V3.45h.293A34.25,34.25,0,0,1,79.469,37.661v.293h3.45v-.293A37.7,37.7,0,0,0,45.259,0"
                transform="translate(2.351 22)"
                fill="#1b526d"
              />
            </svg>
          );
          case 'phone-blue':
            return (
              <svg class="graphic-phone-blue graphic-blue" xmlns="http://www.w3.org/2000/svg" width="107" viewBox="0 0 107 107">
                <path class="tertiary" d="M1039.362,2072.3a53.5,53.5,0,1,1-53.5-53.5,53.5,53.5,0,0,1,53.5,53.5" transform="translate(-932.362 -2018.801)" fill="#d3e8f2" />
                <path
                  class="secondary"
                  d="M22.2,64.456c7.091,4.1,16.659,6.886,29.011,5.084l.665-15.495L35.926,49.6c-1.383.99-3.734,2.838-5.125,3.818,0,0-3.255-.784-7.707-4.96l-1.129-1.087c-4.176-4.453-4.959-7.707-4.959-7.707.98-1.391,2.827-3.742,3.818-5.125L16.373,18.58.879,19.245S-6.621,46.459,22.2,64.456"
                  transform="translate(21 14.294)"
                  fill="#5ba6bf"
                />
                <path
                  class="primary"
                  d="M45.259,26.4h-.293v3.45h.293A18.784,18.784,0,0,1,64.022,48.608V48.9h3.449v-.293A22.238,22.238,0,0,0,45.259,26.4"
                  transform="translate(2.351 11.053)"
                  fill="#1b526d"
                />
                <path
                  class="primary"
                  data-name="graphic-phone-yellow-sound"
                  d="M45.259,13.255h-.293V16.7h.293A26.484,26.484,0,0,1,71.712,43.158v.293h3.45v-.293a29.937,29.937,0,0,0-29.9-29.9"
                  transform="translate(2.351 16.503)"
                  fill="#1b526d"
                />
                <path
                  class="primary"
                  data-name="graphic-phone-yellow-sound"
                  d="M45.259,0h-.293V3.45h.293A34.25,34.25,0,0,1,79.469,37.661v.293h3.45v-.293A37.7,37.7,0,0,0,45.259,0"
                  transform="translate(2.351 22)"
                  fill="#1b526d"
                />
              </svg>
            );

        default:
          return <h1>No project match</h1>;
      }
    };

    return <Host>{icon()}</Host>;
  }
}
